module.exports = __webpack_public_path__ + "img/IMG_9701_L_Foamcore_MockedUp.6560c47e.jpg";